import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { System } from '../../types'

import * as actions from './actions'

export type State = System

const initialState: State = {
  colNum: 2,
  concreteModalOpen: false,
}

export default reducerWithInitialState(initialState).case(
  actions.updateSystem,
  (state, system) => {
    return { ...state, ...system }
  },
)
